import { render, staticRenderFns } from "./eod-acls.vue?vue&type=template&id=25bffb96&scoped=true"
import script from "./eod-acls.vue?vue&type=script&lang=js"
export * from "./eod-acls.vue?vue&type=script&lang=js"
import style0 from "./eod-acls.vue?vue&type=style&index=0&id=25bffb96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bffb96",
  null
  
)

export default component.exports